"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationUtils = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const common_1 = require("@nestjs/common");
const entities_1 = require("../entities");
let NotificationUtils = class NotificationUtils {
    constructor(dataSource) {
        this.dataSource = dataSource;
    }
    async getNotificationDetailsByEvent(event) {
        const repo = await this.dataSource.getRepository(entities_1.NotificationEventParameterMapping)
            .createQueryBuilder("eventParam")
            .leftJoinAndSelect("eventParam.eventType", "event")
            .leftJoinAndSelect("eventParam.parameterDefinition", "parameterDefinition")
            .where("event.name = :name", { name: event })
            .select("parameterDefinition.key", "parameterKey")
            .getRawMany();
        return repo;
    }
};
exports.NotificationUtils = NotificationUtils;
exports.NotificationUtils = NotificationUtils = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_1.DataSource !== "undefined" && typeorm_1.DataSource) === "function" ? _a : Object])
], NotificationUtils);
